/**
 * Check if address is valid
 * @param {string} fullAddress - Full address string
 * @returns {boolean} - True if address is valid
 */
export const hasValidAddress = (fullAddress) => {
	return Boolean(fullAddress.trim());
};
